// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----index-module---footer---329-w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/index.module.css
// module id = 426
// module chunks = 168707334958949